import { Injectable } from '@angular/core';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, updateCurrentUser } from 'firebase/auth';
import { signOut } from 'firebase/auth';
import firebase from 'firebase/compat/app';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private auth = getAuth();
  private isAdminSubject = new BehaviorSubject<boolean>(false);
  private isLoggedIn = new BehaviorSubject<boolean>(false);
  public isAdmin$ = this.isAdminSubject.asObservable();
  public isLoggedIn$ = this.isLoggedIn.asObservable();

  constructor() {
    onAuthStateChanged(this.auth, async (user) => {
      if (user) {
        const userDoc = await firebase.firestore().collection('teacher').doc(user.uid).get();
        const isAdmin = userDoc.exists && !!userDoc.data()?.['isAdmin'];
        this.isAdminSubject.next(isAdmin);
        this.isLoggedIn.next(true);
      } else {
        this.isAdminSubject.next(false);
        this.isLoggedIn.next(false);
      }
    });
  }

  submitLogIn(userEmail: string, password: string): Promise<boolean> {
    this.auth = getAuth();
    return signInWithEmailAndPassword(this.auth, userEmail, password)
      .then((userCredential) => {
        const user = userCredential.user;
        return updateCurrentUser(this.auth, user).then(() => true);
      })
      .catch((error) => {
        console.error("Login failed:", error.message);
        return false;
      });
  }


  getUID() {
    var uid = this.auth.currentUser?.uid;
    return uid;
  }

  userSignOut() {
    signOut(this.auth).then(() => {
      this.isAdminSubject.next(false);
    });
  }
}
